var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(0.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 12,
    height: 8,
    rx: 1,
    transform: "translate(10.721)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 12,
    height: 8,
    rx: 1,
    transform: "translate(20.721 14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 12,
    height: 8,
    rx: 1,
    transform: "translate(-0.279 14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M42.029,235.751h-4.37V225.98",
    transform: "translate(-20.793 -218)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M37.659,235.751h4.37V225.98",
    transform: "translate(-25.163 -218)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 44,
    height: 44,
    transform: "translate(-0.279)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.185675d6a3131a1cc0f88149711c1182.svg";
export { ForwardRef as ReactComponent };